import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div>
        This MLB Dashboard is an independent project created for educational and
        informational purposes. This site is not affiliated with, endorsed by,
        sponsored by, or associated with Major League Baseball, its teams, or
        its partners. All team names, logos, and trademarks are the property of
        their respective owners.
      </div>
      <div>
        Data provided by the MLB Stats API. This site is not affiliated with or
        endorsed by Major League Baseball.
      </div>
    </footer>
  );
};

export default Footer;
